// extracted by mini-css-extract-plugin
export default {"pageContainer":"StudentAttendancePage_pageContainer__Xa8oJ","filtersRow":"StudentAttendancePage_filtersRow__5AedU","tabContent":"StudentAttendancePage_tabContent__JON-9"};